// Route Search Constants
export const ROUTE_SEARCH_CONSTANTS = {
  // Search Types
  SEARCH_TYPE: {
    ROUTE: 'route',
    INSPECTION: 'inspection'
  },

  // Route Search Fields
  ROUTE_FIELDS: {
    ROUTE_ID: 'routeId',
    ROUTE_NAME: 'routeName',
    OPERATIONAL_AREA: 'operationalArea',
    CLIENT: 'client',
    STATUS: 'status'
  },

  // Inspection Search Fields
  INSPECTION_FIELDS: {
    INSPECTION_ID: 'inspectionId',
    ROUTE_NAME: 'routeName',
    INSPECTION_DATE: 'inspectionDate',
    INSPECTION_TYPE: 'inspectionType',
    VENDOR: 'vendor',
    STATUS: 'status'
  },

  // API Endpoints
  API_ENDPOINTS: {
    ROUTE_SEARCH: '/api/route/search',
    INSPECTION_SEARCH: '/api/inspection/search'
  },

  // Status Options
  ROUTE_STATUS_OPTIONS: [
    { value: 'active', label: 'Active' },
    { value: 'inactive', label: 'Inactive' },
    { value: 'maintenance', label: 'Under Maintenance' },
    { value: 'decommissioned', label: 'Decommissioned' }
  ],

  INSPECTION_STATUS_OPTIONS: [
    { value: 'completed', label: 'Completed' },
    { value: 'in_progress', label: 'In Progress' },
    { value: 'scheduled', label: 'Scheduled' },
    { value: 'cancelled', label: 'Cancelled' }
  ],

  // Inspection Types
  INSPECTION_TYPE_OPTIONS: [
    { value: 'ili', label: 'ILI (In-Line Inspection)' },
    { value: 'hydro_test', label: 'Hydro Test' },
    { value: 'visual', label: 'Visual Inspection' },
    { value: 'ultrasonic', label: 'Ultrasonic Testing' },
    { value: 'magnetic_particle', label: 'Magnetic Particle Testing' },
    { value: 'dye_penetrant', label: 'Dye Penetrant Testing' }
  ],

  // Grid Column Configuration
  ROUTE_GRID_COLUMNS: [
    {
      key: 'routeId',
      label: 'Route ID',
      sortable: true,
      width: '15%'
    },
    {
      key: 'routeName',
      label: 'Route Name',
      sortable: true,
      width: '25%'
    },
    {
      key: 'operationalArea',
      label: 'Operational Area',
      sortable: true,
      width: '20%'
    },
    {
      key: 'client',
      label: 'Client',
      sortable: true,
      width: '20%'
    },
    {
      key: 'status',
      label: 'Status',
      sortable: true,
      width: '15%'
    },
    {
      key: 'actions',
      label: 'Actions',
      sortable: false,
      width: '5%'
    }
  ],

  INSPECTION_GRID_COLUMNS: [
    {
      key: 'inspectionId',
      label: 'Inspection ID',
      sortable: true,
      width: '15%'
    },
    {
      key: 'routeName',
      label: 'Route Name',
      sortable: true,
      width: '20%'
    },
    {
      key: 'inspectionDate',
      label: 'Inspection Date',
      sortable: true,
      width: '15%'
    },
    {
      key: 'inspectionType',
      label: 'Type',
      sortable: true,
      width: '15%'
    },
    {
      key: 'vendor',
      label: 'Vendor',
      sortable: true,
      width: '15%'
    },
    {
      key: 'status',
      label: 'Status',
      sortable: true,
      width: '15%'
    },
    {
      key: 'actions',
      label: 'Actions',
      sortable: false,
      width: '5%'
    }
  ],

  // Pagination
  PAGINATION: {
    DEFAULT_PAGE_SIZE: 10,
    PAGE_SIZE_OPTIONS: [5, 10, 20, 50, 100]
  },

  // Messages
  MESSAGES: {
    ROUTE_SEARCH_SUCCESS: 'Route search completed successfully',
    INSPECTION_SEARCH_SUCCESS: 'Inspection search completed successfully',
    ROUTE_SEARCH_ERROR: 'Error performing route search',
    INSPECTION_SEARCH_ERROR: 'Error performing inspection search',
    NO_ROUTE_CRITERIA: 'Please enter at least one search criteria for routes',
    NO_INSPECTION_CRITERIA: 'Please enter at least one search criteria for inspections',
    NO_ROUTES_FOUND: 'No routes found matching your search criteria',
    NO_INSPECTIONS_FOUND: 'No inspections found matching your search criteria'
  }
};

export default ROUTE_SEARCH_CONSTANTS;
